import './controllers';

import SmoothScroll from 'smooth-scroll';
import { ready } from './controllers/util';

const scrollConfig = {
    speed: 300,
    speedAsDuration: true,
    header: '.site-nav',
    updateURL: false,
};

let contentLoaded = false,
    scrollTo = null;
window.__scroll = new SmoothScroll('.notAClass', scrollConfig);
window.setTimeout(() => {
    contentLoaded = true;
    if (scrollTo) {
        window.__scroll.cancelScroll();
        window.__scroll.animateScroll(scrollTo);
    }
}, 500);

const handleHash = function (e) {
    const hash = window.location.hash;
    if (!hash) {
        return false;
    }
    window.__scroll = new SmoothScroll('.notAClass', scrollConfig);
    if (hash.length) {
        const id = hash.replace('#', '') + '_';
        const el = document.getElementById(id);
        if (!el) {
            return false;
        }
        const doScroll = () => {
            contentLoaded = true;
            window.__scroll.cancelScroll();
            window.__scroll.animateScroll(el);
        };

        if (contentLoaded) {
            setTimeout(doScroll, 250);
        } else {
            scrollTo = el;
        }
    }
};

ready(handleHash);
